// HAUS: String, Line 01. Cords drawn on load (hero) and on scroll (pieces), plus cord colour filter.
if (!customElements.get('haus-string')) {
  customElements.define('haus-string', class extends HTMLElement {
    connectedCallback() {
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.cords = Array.from(this.querySelectorAll('[data-cord]'));
      this.cards = Array.from(this.querySelectorAll('[data-key-card]'));
      this.chips = Array.from(this.querySelectorAll('.hs__chip'));
      this.count = this.querySelector('[data-count]');
      this.group = this.querySelector('[data-group]');
      this.tick = false;
      this.onResize = () => { this.offsets(); this.layout(); };
      this.onScroll = this.onScroll.bind(this);
      this.chips.forEach((b) => b.addEventListener('click', () => this.filter(b.dataset.key)));
      window.addEventListener('scroll', this.onScroll, { passive: true });
      if ('ResizeObserver' in window) { this.ro = new ResizeObserver(this.onResize); this.ro.observe(this); }
      window.addEventListener('resize', this.onResize);
      this.offsets();
      this.layout();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      if (this.ro) this.ro.disconnect();
    }
    mobile() { return window.innerWidth < 750; }
    curve(p) {
      const f = (n) => n.toFixed(1);
      let d = 'M' + f(p[0][0]) + ',' + f(p[0][1]);
      for (let i = 0; i < p.length - 1; i++) {
        const a = p[i - 1] || p[i], b = p[i], c = p[i + 1], e = p[i + 2] || c;
        d += ' C' + f(b[0] + (c[0] - a[0]) / 6) + ',' + f(b[1] + (c[1] - a[1]) / 6) + ' ' + f(c[0] - (e[0] - b[0]) / 6) + ',' + f(c[1] - (e[1] - b[1]) / 6) + ' ' + f(c[0]) + ',' + f(c[1]);
      }
      return d;
    }
    layout() {
      this.cords.forEach((svg) => {
        const r = svg.getBoundingClientRect();
        const w = r.width, h = r.height;
        if (!w || !h) return;
        const mirror = svg.hasAttribute('data-mirror');
        const raw = (this.mobile() ? svg.dataset.mob : svg.dataset.desk) || svg.dataset.desk;
        const pts = raw.trim().split(' ').filter(Boolean).map((s) => {
          const xy = s.split(',');
          let x = parseFloat(xy[0]);
          if (mirror) x = 100 - x;
          return [x / 100 * w, parseFloat(xy[1]) / 100 * h];
        });
        svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
        const path = svg.querySelector('path');
        path.setAttribute('d', this.curve(pts));
        const len = path.getTotalLength();
        svg._len = len;
        path.style.strokeDasharray = len + ' ' + len;
        if (this.reduce) { path.style.strokeDashoffset = '0'; return; }
        if (svg.dataset.mode === 'load') {
          if (!svg._drawn) {
            svg._drawn = true;
            const delay = svg.dataset.delay || '.4';
            path.style.transition = 'none';
            path.style.strokeDashoffset = String(len);
            path.getBoundingClientRect();
            path.style.transition = 'stroke-dashoffset 3.4s cubic-bezier(.6,0,.3,1) ' + delay + 's';
            path.style.strokeDashoffset = '0';
          } else {
            path.style.transition = 'none';
            path.style.strokeDashoffset = '0';
          }
        }
      });
      this.draw();
    }
    onScroll() {
      if (this.tick) return;
      this.tick = true;
      requestAnimationFrame(() => { this.tick = false; this.draw(); });
    }
    draw() {
      const vh = window.innerHeight;
      this.cords.forEach((svg) => {
        if (svg.dataset.mode !== 'scroll' || !svg._len) return;
        const path = svg.querySelector('path');
        if (this.reduce) { path.style.strokeDashoffset = '0'; return; }
        const r = svg.getBoundingClientRect();
        let p = (vh * 0.9 - r.top) / (r.height + vh * 0.3);
        p = Math.min(1, Math.max(0, p));
        path.style.strokeDashoffset = String(svg._len * (1 - p));
      });
    }
    filter(key) {
      let shown = 0;
      this.chips.forEach((b) => b.setAttribute('aria-pressed', b.dataset.key === key ? 'true' : 'false'));
      this.cards.forEach((el) => {
        const k = el.dataset.keyCard;
        const on = key === 'all' || k === key || k === 'any';
        el.hidden = !on;
        if (on) shown++;
      });
      if (this.group) this.group.hidden = !this.cards.some((el) => el.hasAttribute('data-set') && !el.hidden);
      if (this.count) this.count.textContent = shown + ' of ' + this.cards.length;
      this.offsets();
      this.layout();
    }
    offsets() {
      const steps = this.mobile() ? [0, 48] : [0, 80, 40];
      let i = 0;
      this.cards.forEach((el) => {
        if (el.hidden) return;
        el.style.marginTop = steps[i % steps.length] + 'px';
        i++;
      });
    }
  });
}